
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'flag-nl': {
    width: 640,
    height: 480,
    viewBox: '0 0 640 480',
    data: '<g fill-rule="evenodd" stroke-width="1pt" transform="scale(1.25 .9375)"><rect pid="0" width="512" height="509.8" _fill="#fff" rx="0" ry="0"/><rect pid="1" width="512" height="169.9" y="342.1" _fill="#21468b" rx="0" ry="0"/><path pid="2" _fill="#ae1c28" d="M0 0h512v170H0z"/></g>'
  }
})
